import React from "react";
import Linkify from "react-linkify";
import appConstants from "../../../../../appConstants";
import MessageMetaData from "./MessageMetaData";
import ChoiceRenderer from "../Header/MCQMessages/ChoiceRenderer";

const TextMessage = (props) => {
  const { classes } = props;
  const onReplyMsgSelected = () => {
    props.onReplyMsgSelected(props.msg);
  };
  return (
    <React.Fragment>
      {props.msg.messageType === appConstants.MESSAGE_TYPE.Dispatcher ? (
        /* Display independent message sent to driver app */
        <div
          className={`${classes.scMessageText} ${classes.scMessageContentSentScMessagText}`}
        >
          <div className={`${classes.scMessageContentSentReply} ${props.msg.isUrgent ? classes.urgentMessage : ""}`.trim()}>
            <Linkify properties={{ target: "_blank" }}>
              {props.msg.message}
              {props.msg.choice?.length > 0 && ( //required when sending message to driver with options
                <ChoiceRenderer choiceData={props.msg.choice} />
              )}
            </Linkify>
            <div className={classes.timeStyle}>
              {props.convertTime(props.msg.messageDateTs)}{" "}
              {props.renderReadIcon(props.msg.isRead, classes)}
            </div>
          </div>
          <div className={classes.waitingResponseStyle}>
            <div>Waiting for response</div>
          </div>
        </div>
      ) : ( 
        /* Display independent message received from driver app */
        <div
          className={`${classes.scMessageText} ${classes.scMessageContentReceivedScMessageText}`}
        >
          <div className={classes.scMessageContentReceivedReply}>
            {props.msg.metadata && (
              <MessageMetaData
                color={props.metadataColor}
                metadata={props.msg.metadata}
              ></MessageMetaData>
            )}
            <Linkify properties={{ target: "_blank" }}>
              {props.msg.message}
            </Linkify>
            <div className={classes.timeStyle}>
              {props.convertTime(props.msg.messageDateTs)}
            </div>
          </div>
          <div className={classes.sendResponse}>
            <div onClick={onReplyMsgSelected}>Send response</div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default TextMessage;
